.field {
  display: flex;
  flex-direction: column;
  gap: 0.375rem;
  width: 100%;
}

/* ── Label ── */
.label {
  display: inline-flex;
  align-items: flex-start;
  gap: 0.125rem;
  color: var(--text-secondary);
}
.required {
  color: var(--error-solid);
}
.srOnly {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0 0 0 0);
  white-space: nowrap;
  border: 0;
}

/* Compact stand-in for the chips when the trigger is too narrow for them (`summarizeSelection`). */
.summary {
  color: var(--text-primary);
  white-space: nowrap;
}

/* ── Trigger box (chips + filter input) ── */
.box {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.25rem 0.375rem;
  width: 100%;
  border: 1px solid var(--border);
  border-radius: 0.5rem;
  background: var(--surface);
  box-shadow: var(--shadow-xs);
  color: var(--text-primary);
  cursor: text;
  box-sizing: border-box;
  transition:
    border-color 150ms ease,
    box-shadow 150ms ease;
}
.md {
  padding: 0.4375rem 0.75rem;
}
.sm {
  padding: 0.3125rem 0.75rem;
}

.box:focus-within {
  outline: none;
  border-color: var(--brand-solid);
  box-shadow: var(--focus-ring);
}
.box.error {
  border-color: var(--error-solid);
}
.box.error:focus-within {
  box-shadow: var(--focus-ring-error);
}
.box.disabled {
  background: var(--surface-secondary);
  cursor: not-allowed;
}

.searchIcon {
  flex-shrink: 0;
  color: var(--text-quaternary);
}

.input {
  flex: 1 1 4rem;
  min-width: 4rem;
  border: 0;
  padding: 0.125rem 0;
  background: transparent;
  color: var(--text-primary);
  font-family: var(--font-family-base);
  font-size: var(--text-md-font-size);
  line-height: var(--text-md-line-height);
}
.input:focus {
  outline: none;
}
.input::placeholder {
  color: var(--text-quaternary);
}
.input:disabled {
  cursor: not-allowed;
}

.chevron {
  flex-shrink: 0;
  margin-left: auto;
  color: var(--text-quaternary);
}

.shortcut {
  flex-shrink: 0;
  padding: 0.0625rem 0.25rem;
  border: 1px solid var(--border);
  border-radius: 0.25rem;
  color: var(--text-quaternary);
  font-family: var(--font-family-base);
  font-size: var(--text-xs-font-size);
  line-height: var(--text-xs-line-height);
}

/* ── Footer (Reset / Select all) ── */
.footerSpacer {
  flex: 1 1 0;
}

/* ── Empty search state ── */
.noResults {
  padding: 0.625rem 0.75rem;
}
.noResultsText {
  color: var(--text-tertiary);
}

/* ── Hint / error message ── */
.hint {
  color: var(--text-tertiary);
}
.errorText {
  color: var(--error-solid);
}

@media (forced-colors: active) {
  .box:focus-within {
    outline: 2px solid Highlight;
    outline-offset: 2px;
  }
}
